import moment from 'moment';
import axiosInstance from '../components/utils/axios/axiosInstance';

export function setReservationGraphDefault() {
  const today = moment(new Date()).format('DD.MM.YYYY');
  return async (dispatch) => {
    await axiosInstance
      .get('api/reservation/getReservationGraph', {
        params: {
          parkinglotId: '312',
          reservationDate: today,
          permanentPlaces: true
        }
      })
      .then((res) => {
        dispatch({ type: 'RESERVATION_GRAPH', data: res.data });
      });
  };
}

export function getReservationGraph(date, lot) {
  const formattedDate = moment(date).format('DD.MM.YYYY');
  return async (dispatch) => {
    await axiosInstance
      .get('api/reservation/getReservationGraph', {
        params: {
          parkinglotId: '312',
          reservationDate: formattedDate,
          permanentPlaces: true
        }
      })
      .then((res) => {
        dispatch({ type: 'RESERVATION_GRAPH', data: res.data });
      });
  };
}
